import React from "react";
import { Box, Button, Card, Chip, Stack, Typography } from "@mui/material";
import SectionFrame from "../SectionFrame";
import { EditableText } from "../InlineEditable";

const SAMPLE_PRODUCTS = [
  { name: "Producto destacado 1", category: "Categoría", price: "$ 00.000" },
  { name: "Producto destacado 2", category: "Categoría", price: "$ 00.000" },
  { name: "Producto destacado 3", category: "Categoría", price: "$ 00.000" },
  { name: "Producto destacado 4", category: "Categoría", price: "$ 00.000" },
];

export default function FeaturedProductsSection({ form, active, device, productsEnabled, onSelect, onCommit, onCommitMany, disabled }) {
  const isMobile = device === "mobile";
  const copy = form.catalog.featured || {};
  const primary = form.theme.primaryColor || "#F35A3A";
  const secondary = form.theme.secondaryColor || "#19242F";
  const enabled = productsEnabled && form.sections.showProducts !== false && form.sections.showFeatured !== false;
  const toggle = (next) => onCommitMany
    ? onCommitMany({ "sections.showProducts": true, "sections.showFeatured": next })
    : onCommit("sections.showFeatured", next);

  return (
    <SectionFrame id="featured" label="Productos destacados" active={active} enabled={enabled} onSelect={onSelect} onToggle={productsEnabled ? toggle : undefined}>
      <Box sx={{ px: isMobile ? 2.2 : 5.5, py: isMobile ? 6 : 8, overflow: "hidden", background: `linear-gradient(135deg, ${form.theme.backgroundColor || "#EEF0F5"}, ${form.theme.surfaceColor || "#fff"})` }}>
        <Box sx={{ maxWidth: 1440, mx: "auto" }}>
          <Box sx={{ mb: 3.5, maxWidth: 760 }}>
            <EditableText value={copy.eyebrow} fallback="Catálogo" disabled={disabled} onSave={(value) => onCommit("catalog.featured.eyebrow", value)} sx={{ color: primary, textTransform: "uppercase", letterSpacing: 1.2, fontWeight: 900, fontSize: 13 }} />
            <Box sx={{ mt: 0.6 }}><EditableText value={copy.title} fallback="Productos destacados" disabled={disabled} onSave={(value) => onCommit("catalog.featured.title", value)} sx={{ color: secondary, fontWeight: 950, fontSize: isMobile ? 34 : 45, letterSpacing: "-.035em" }} /></Box>
            <Box sx={{ mt: 1 }}><EditableText value={copy.subtitle} fallback="Conocé las últimas novedades del catálogo." disabled={disabled} multiline onSave={(value) => onCommit("catalog.featured.subtitle", value)} sx={{ color: form.theme.mutedTextColor || "#5B5D73", lineHeight: 1.7 }} /></Box>
          </Box>
          <Box sx={{ mx: isMobile ? -2.2 : -5.5, px: isMobile ? 2.2 : 5.5, overflow: "hidden", py: 1.5, maskImage: "linear-gradient(90deg, transparent 0%, black 7%, black 93%, transparent 100%)" }}>
            <Stack direction="row" spacing={1.6} sx={{ width: "max-content" }}>
              {SAMPLE_PRODUCTS.map((product, index) => (
                <Card key={product.name} elevation={0} sx={{ width: isMobile ? 230 : 280, flex: "0 0 auto", overflow: "hidden", borderRadius: 3, border: "1px solid rgba(25,36,47,.08)", bgcolor: "rgba(255,255,255,.96)", boxShadow: "7px 8px 20px rgba(35,38,58,.10)" }}>
                  <Box sx={{ height: isMobile ? 150 : 165, bgcolor: "rgba(25,36,47,.06)", display: "grid", placeItems: "center" }}><Typography variant="body2" sx={{ color: "rgba(25,36,47,.42)", fontWeight: 850 }}>Imagen real del producto</Typography></Box>
                  <Box sx={{ p: 2 }}>
                    <Chip size="small" label={product.category} sx={{ mb: 1, fontWeight: 800 }} />
                    <Typography sx={{ fontWeight: 950, color: secondary }}>{product.name}</Typography>
                    <Typography sx={{ mt: 1, fontWeight: 950, color: primary }}>{product.price}</Typography>
                    <Button size="small" sx={{ mt: 1, px: 0, color: secondary, textTransform: "none", fontWeight: 900 }}>{index === 0 ? copy.ctaLabel || "Ver detalle" : "Ver detalle"}</Button>
                  </Box>
                </Card>
              ))}
            </Stack>
          </Box>
        </Box>
      </Box>
    </SectionFrame>
  );
}
